/**
 * Charity search query helpers.
 *
 * The backend matches EINs as bare digits (e.g. 990903497), but EINs are
 * conventionally written and displayed with a dash (99-0903497). Users copy the
 * dashed form, which returns no results. Strip the punctuation before querying
 * when the term looks like an EIN, and leave name searches untouched.
 */

const EIN_PATTERN = /^\d{2}-?\d{7}$/

export function looksLikeEin(term) {
  return EIN_PATTERN.test((term ?? '').trim())
}

/** Strip non-digits and cap at 9 — the canonical stored EIN shape. */
export function normalizeEin(value) {
  return String(value ?? '')
    .replace(/\D/g, '')
    .slice(0, 9)
}

/** True when the value is a complete 9-digit (or XX-XXXXXXX) EIN. */
export function isValidEin(value) {
  return looksLikeEin(value)
}

export function normalizeCharityQuery(term) {
  const trimmed = (term ?? '').trim()
  return looksLikeEin(trimmed) ? trimmed.replace(/\D/g, '') : trimmed
}

// For display formatting, use `formatEin` from lib/strings.js.
